import { useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';

import { AdvertiserContext } from '../../AdvertiserContext';
import { CampaignWizardContext } from '../../hooks/useCampaignWizard';
import CampaignPageHeader from './partials/CampaignPageHeader';
import CampaignWizard from './partials/CampaignWizard/CampaignWizard';
import CampaignWizardSubmissionConfirmation from './partials/CampaignWizard/CampaignWizardSubmissionConfirmation';
import CampaignWizardSubmissionLoadingConfirmation from './partials/CampaignWizard/CampaignWizardSubmissionLoadingConfirmation';
import useCampaignWizard from '../../hooks/useCampaignWizard';
import usePageTitle from '../../hooks/usePageTitle';

export default function CampaignEditPage() {
    const { advertiserContext } = useContext(AdvertiserContext);

    const params = useParams();
    const location = useLocation();

    const [campaignId, setCampaignId] = useState<number>(0);
    const [campaignChangeRequestId, setCampaignChangeRequestId] = useState<number | null>(null);

    useEffect(() => {
        if (params?.id) {
            setCampaignId(params.id as any as number);
        }

        if (location?.state?.campaignChangeRequestId > 0) {
            setCampaignChangeRequestId(location.state.campaignChangeRequestId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.state]);

    const campaignWizard = useCampaignWizard({
        dealer: advertiserContext.dealer,
        campaignId: campaignId,
        campaignChangeRequestId: campaignChangeRequestId,
    });

    const { campaign, wasRecentlyLoaded, wasRecentlySubmitted } = campaignWizard;

    // build & render title
    const campaignName = campaign?.campaignName;
    usePageTitle({ segments: [campaignName ? `Edit Campaign "${campaignName}"` : 'Edit Campaign'] });

    return (
        <CampaignWizardContext.Provider value={campaignWizard}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: 'auto',
                    pb: 3,
                }}
            >
                {!wasRecentlySubmitted && (
                    <>
                        <CampaignPageHeader />

                        <Box>
                            <CampaignWizard campaignWizard={campaignWizard} />
                        </Box>
                    </>
                )}

                {wasRecentlySubmitted && (
                    <>
                        {!wasRecentlyLoaded && <CampaignWizardSubmissionLoadingConfirmation campaign={campaign} />}

                        {wasRecentlyLoaded && <CampaignWizardSubmissionConfirmation campaign={campaign} />}
                    </>
                )}
            </Box>
        </CampaignWizardContext.Provider>
    );
}
